<template>
  <div class="min-h-screen">
    <div class="flex min-h-screen">
      <aside class="hidden w-[190px] shrink-0 border-r border-slate-200 bg-white lg:block">
        <div class=" py-5">
          <div class="flex items-center justify-between px-5">
            <div>
              <div class="text-sm font-bold text-slate-900">Gate Operator</div>
              <div class="mt-0.5 text-xs text-slate-500">Entry / Exit control</div>
            </div>
           
          </div>

          <div class="mt-4 bg-slate-50 p-3 ring-1 ring-slate-200">
            <div class="text-xs font-semibold text-slate-700">{{ user?.name }}</div>
            <div class="mt-0.5 text-[11px] text-slate-500">@{{ user?.username }}</div>
          </div>
        </div>

        <nav class=" pb-6">
          <RouterLink v-for="item in nav" :key="item.to" :to="item.to"
            class="group flex items-center justify-between  px-3 py-2 text-sm font-semibold transition"
            :class="isActive(item.to) ? 'w-full bg-sky-50 text-sky-700' : 'w-full text-slate-700 hover:bg-slate-50'">
            <span class="flex items-center gap-2">
              <span class="text-base">{{ item.icon }}</span>
              {{ item.label }}
            </span>
            <span v-if="item.badge" class="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-700 ring-1 ring-slate-200">
              {{ item.badge }}
            </span>
          </RouterLink>
        </nav>

        <!-- <div class="mt-auto px-5 pb-6">
          <button
            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50"
            @click="logout"
          >
            Sign out
          </button>
        </div> -->
      </aside>

      <div class="flex min-w-0 flex-1 flex-col">
        <header class="sticky top-0 z-10 border-b border-slate-200 bg-white/80 backdrop-blur">
          <div class="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
            <div class="min-w-0">
              <div class="truncate text-sm font-bold text-slate-900">PM System</div>
              <!-- <div class="mt-0.5 text-xs text-slate-500">Operator</div> -->
            </div>
            <div class="flex items-center gap-2">
              <button
                @click="logout"
                class="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm hover:bg-slate-50"
              >
                Logout
            </button>
              <!-- <button
                class="rounded-lg bg-sky-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-sky-500 lg:hidden"
                @click="logout"
              >
                Sign out
              </button> -->
            </div>
          </div>
        </header>

        <main class="mx-auto w-full max-w-6xl flex-1 px-4 py-6 pb-24 lg:pb-6">
          <RouterView />
        </main>

        <footer class="border-t border-slate-200 bg-white">
          <div class="mx-auto max-w-6xl px-4 py-4 text-xs text-slate-500">
            Powerd By Abima Business Solutions
          </div>
        </footer>

        <!-- Mobile bottom nav -->
        <nav class="fixed inset-x-0 bottom-0 z-20 border-t border-slate-200 bg-white/90 backdrop-blur lg:hidden">
          <div class="mx-auto max-w-6xl px-2">
            <div class="grid grid-cols-3 gap-1 py-2">
              <RouterLink
                v-for="item in mobileNav"
                :key="item.to"
                :to="item.to"
                class="flex flex-col items-center justify-center rounded-lg px-2 py-1.5 text-[11px] font-semibold transition"
                :class="isActive(item.to) ? 'bg-sky-50 text-sky-700' : 'text-slate-600 hover:bg-slate-50'"
              >
                <div class="text-base leading-none">{{ item.icon }}</div>
                <div class="mt-1 truncate">{{ item.shortLabel }}</div>
              </RouterLink>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { toast } from "@/toast";

const store = useStore();
const route = useRoute();
const router = useRouter();

const user = computed(() => store.getters.authedUser);
const activeCount = computed(() => store.getters.activeSessions.length);

const nav = computed(() => [
  { to: "/operator/entry-exit", label: "Entry / Exit", icon: "🚗" },
  { to: "/operator/active", label: "Active vehicles", icon: "🅿️", badge: activeCount.value ? String(activeCount.value) : "" },
  { to: "/operator/history", label: "History", icon: "🧾" },
]);

const mobileNav = computed(() => [
  { to: "/operator/entry-exit", shortLabel: "Gate", icon: "🚗" },
  { to: "/operator/active", shortLabel: "Active", icon: "🅿️" },
  { to: "/operator/history", shortLabel: "History", icon: "🧾" },
]);

function isActive(path) {
  return String(route.path || "").startsWith(path);
}

async function logout() {
  await store.dispatch("logout");
  toast.info("Signed out.");
  router.push("/login");
}
</script>

